import BodyPartsQuiz from "../../components/Nursery/EnvironmentScience/BodyPartsQuiz";
import MatchBodyParts from "../../components/Nursery/EnvironmentScience/MatchBodyParts";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - Environment Science(EVS) - Body Parts"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/body-parts/choose-correct", title: "Identify Correct Body Parts", component: BodyPartsQuiz},
    { url: "/nursery/environmental-science/body-parts/match-bodyparts", title: "Match Body parts", component: MatchBodyParts},
];


export default topics;